<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="motivonaovenda vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("motivos-nao-venda") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("motivos-nao-venda")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <!-- BOTÕES -->
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create&&!motivonaovendaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'ven-motivo-nao-venda-new',
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="getSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <!-- LISTAGEM -->
                    <div class="motivonaovenda-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="allmotivosnaovenda"
                            :mobile-cards="false"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'ven-motivo-nao-venda-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t("ativo") }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t("inativo") }}</b-tag
                                    >
                                </div>
                                <div v-if="f.key == 'excluir' && !motivonaovendaIntegracao && permissao.update" >
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'"
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'"
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar')"
                                    />
                                </div>
                                <div v-else-if="f.key == 'codigo'">
                                    <pre>{{ props.row['codigo'] }}</pre>
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import MotivoNaoVendaService from "@/services/MotivoNaoVendaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name == "ven-motivo-nao-venda-new" ||
            to.name == "ven-motivo-nao-venda-edit"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            motivonaovendaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("MOTIVONAOVENDA"),
            allmotivosnaovenda: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new MotivoNaoVendaService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: 55, sortable: true },
                { key: "descricao", width: null, sortable: true },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 70, sortable: false },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            column: "descricao",
            order: "asc",
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            rotaAninhada: false
        };
    },
    created() {
        if (
            this.$route.name == "ven-motivo-nao-venda-new" ||
            this.$route.name == "ven-motivo-nao-venda-edit"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        // Seleciona o valor na posição do array de opções de paginação
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "vendas",
            "venda-motivo-nao-venda"
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivos-nao-venda" },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.order,
                    this.column,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allmotivosnaovenda = value;
                    this.isEmpty = this.allmotivosnaovenda.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar motivos de não venda.", e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                let motivonaovendalist = body.content.map((mf) => {
                    return {
                        id: mf.idmotivonaovenda,
                        codigo: mf.idmotivonaovendaerp,
                        descricao: mf.descricao,
                        situacao: mf.situacao,
                    };
                });
                return motivonaovendalist;
            } else {
                return [];
            }
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacao() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1
                        ? "msg-erro-ao-desativar-motivonaovenda"
                        : "msg-erro-ao-reativar-motivonaovenda", 
                    { n: this.$t("chart-motivo-nao-venda") }
                );

            let motivonaovenda = {
                idmotivonaovenda: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(motivonaovenda)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 0
                                    ? "msg-sucesso-ao-desativar-motivonaovenda"
                                    : "msg-sucesso-ao-reativar-motivonaovenda", 
                                { n: this.$t("chart-motivo-nao-venda") }
                            );
                        this.$root.showMessage(
                            "success",
                            tempSuccess,
                            true,
                            false
                        );
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        getSituacao(t) {
            this.situacao = t ? t : this.situacao = this.situacoes[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}

.page {
    position: relative;
    padding-left: 0;
    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>
